import { Accordion } from '@base-ui/react/accordion';
import { ChevronUp } from 'react-bootstrap-icons';

import { SDSFlexbox } from '@repo/sds/SDSFlexbox';
import { SDSText } from '@repo/sds/SDSText';

import './NotificationBlock.scss';

interface NotificationBlockProps {
  title: string;
  children?: React.ReactNode;
  collapsible?: boolean;
  titleDataTestId?: string;
}

export function NotificationBlock({ title, children, collapsible = true, titleDataTestId }: NotificationBlockProps) {
  if (!collapsible) {
    return (
      <div className="NotificationBlock">
        <SDSFlexbox alignItems="center" justifyContent="space-between" fullWidth>
          <SDSText type="body-medium-bold" text={title} dataTestId={titleDataTestId} />
        </SDSFlexbox>
        <div className="NotificationBlock__panel-static">{children}</div>
      </div>
    );
  }

  const itemValue = title.toLowerCase().replace(/\s+/g, '-');
  return (
    <Accordion.Root defaultValue={[itemValue]} className="NotificationBlock">
      <Accordion.Item value={itemValue}>
        <Accordion.Header>
          <Accordion.Trigger className="NotificationBlock__trigger">
            <SDSFlexbox alignItems="center" justifyContent="space-between" fullWidth>
              <SDSText type="body-medium-bold" text={title} dataTestId={titleDataTestId} />
              <ChevronUp className="NotificationBlock__triggerIcon" />
            </SDSFlexbox>
          </Accordion.Trigger>
        </Accordion.Header>
        <Accordion.Panel className="NotificationBlock__panel">{children}</Accordion.Panel>
      </Accordion.Item>
    </Accordion.Root>
  );
}
